import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";
// import { API_PATHS, COMPANY_CODE } from "../utils/constants";
import GratuityDocument from "./GratuityDocument";
import { IoArrowBack } from "react-icons/io5";

const GratuityMonitorPrint = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [gratuityPrintData, setGratuityPrintData] = useState();
  const [gratuityEOSData, setGratuityEOSData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(location.state){
        setGratuityPrintData(location.state.gratuityData);
        setGratuityEOSData(location.state.eosData);
        setLoading(false)
    }
    }, [location]);
    
    console.log("gratuityPrintData:", gratuityPrintData);
//   const onBack = () => navigate("/admin/endOfServiceApproval");
//   
  const onBack = () => {
    navigate("/admin/gratuityMonitor", { state: { item: gratuityEOSData } });
  };

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-normal my-4">Gratuity Print Preview</h2>

        <button
          onClick={onBack}
          className="flex items-center gap-2 bg-gray-700 hover:bg-gray-800 
                            text-white px-4 py-2 rounded-lg 
                            transition-all duration-200 
                            shadow-sm hover:shadow-md"
        >
          <IoArrowBack className="text-lg" />
          Back
        </button>
      </div>

      <div className="flex flex-col items-center h-screen">
        {loading ? (
          <div className="text-center text-gray-500 mt-10">
            Loading Payment Data...
          </div>
        ) : !gratuityPrintData || gratuityPrintData.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">
            No gratuity monitor data available!
          </div>
        ) : (
          <>
            <div className="w-full h-screen border border-gray-300 mb-4">
              <PDFViewer width="100%" height="100%">
                <GratuityDocument gratuityPrintData={gratuityPrintData} />
              </PDFViewer>
            </div>

            <div className="mt-4 mb-6">
              <PDFDownloadLink
                document={
                  <GratuityDocument gratuityPrintData={gratuityPrintData} />
                }
                fileName={`Gratuity_Monitor_${gratuityPrintData?.EmployeeID || "print"}.pdf`}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                {({ loading }) =>
                  loading
                    ? "Preparing PDF..."
                    : "Download Gratuity Monitor Data"
                }
              </PDFDownloadLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GratuityMonitorPrint;
